import { CircularProgress } from '@mui/material';
import { injectIntl } from 'react-intl';

export const DEFAULT_LOADING_DIALOG = 'DEFAULT_LOADING_DIALOG';

const DefaultLoadingDialog = ({ disableShrink = false }) => {
    return (
        <CircularProgress
            disableShrink={disableShrink}
            color="primary"
            sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 100 }}
        />
    );
};

export default injectIntl(DefaultLoadingDialog);
